var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandSidebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "expand_sidebar",
    "data-name": "expand sidebar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "expand_sidebar-2",
    "data-name": "expand sidebar",
    d: "M12.1,30l9.795-10L12.1,10h3.451l9.795,10L15.551,30Zm11.754,0,9.795-10L23.854,10h3.451L37.1,20,27.305,30Z",
    transform: "translate(-12.1 -10)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandSidebar);
export default __webpack_public_path__ + "static/media/expand_sidebar.e384cdd95eedb3c3fdd9875f0f481525.svg";
export { ForwardRef as ReactComponent };